import { render, staticRenderFns } from "./app-menu.vue?vue&type=template&id=1d70afda&scoped=true&"
import script from "./js/app-menu.js?vue&type=script&lang=js&"
export * from "./js/app-menu.js?vue&type=script&lang=js&"
import style0 from "./app-menu.vue?vue&type=style&index=0&id=1d70afda&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d70afda",
  null
  
)

export default component.exports